export interface InputProps {
 type: string
 placeholder?: string
 value?: string
 onChange?: (_value: string, _name: string) => void;
 className?: string

 label?: string
 id?: any
 htmlFor?: any
 name?: any
 min?:any
}

export const Input = ({
 type,
 placeholder,
 value,
 onChange,
 className = "",
 label,
 id,
 htmlFor,
 name,
 min
}: InputProps) => {
 return (
  <>
   {label && <label htmlFor={htmlFor}>{label}</label>}
   <input
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange?.(e?.target?.value, e?.target?.name)}
    id={id}
    name={name}
    min={min}
    className={`w-full ${className}`}
   />
  </>
 )
}
